export default __webpack_public_path__ + "static/media/cpg-study.b84d25a4.svg";